export default __webpack_public_path__ + "static/media/logocalc.21bc9adc.svg";